import get from 'lodash/get';

export const getHasPageViewFired = (state) => get(state, 'pageViewEvent.fired');
